<template>
  <svg width="30px" height="30px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/30x30/check/blue</title>
    <g id="atoms/icons/30x30/check/blue" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M11.7781746,22.0721356 L4.70710678,15.0010678 C4.31658249,14.6105435 4.31658249,13.9773785 4.70710678,13.5868542 C5.09763107,13.19633 5.73079605,13.19633 6.12132034,13.5868542 L12.5002136,19.9652136 L23.8284271,8.63710678 C24.2189514,8.24658249 24.8521164,8.24658249 25.2426407,8.63710678 C25.633165,9.02763107 25.633165,9.66079605 25.2426407,10.0513203 L13.2218254,22.0721356 C13.0415834,22.2523776 12.8096547,22.349431 12.57375,22.3632957 L12.42625,22.3632957 C12.1903453,22.349431 11.9584166,22.2523776 11.7781746,22.0721356 Z" id="Combined-Shape"
      ></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
